import React, { FC } from 'react';
import { generatePath, useHistory } from 'react-router';
import styled from 'styled-components';
import { ROUTES } from '../../../constants/routes';
import { Cell, HeaderCell, Left, NoMatching, RowsWrapper, Underlined, Wrapper } from './TableStyles';

type Props = {
  ConditionsRows: any[];
};
const ConditionsTable: FC<Props> = ({ ConditionsRows }) => {
  const history = useHistory();
  const onClick = row => {
    const path = generatePath(ROUTES.PERMIT, {
      projectId: row.projectId,
      permitId: row.permitId,
    });
    history.push(path);
  };

  return (
    <Wrapper>
      <Row>
        <HeaderCell>
          <Left>Project - Permit</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Activity Title</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Condition Name</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Activity Status</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Follow Up</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Attachment</Left>
        </HeaderCell>
      </Row>
      <RowsWrapper>
        {ConditionsRows.length === 0 && <NoMatching>No matching records found</NoMatching>}
        {ConditionsRows.length > 0 &&
          ConditionsRows.map((condition, index) => {
            return (
              <Row key={index}>
                <Cell>
                  <Left>
                    <Underlined onClick={e => onClick(condition)}>{`${condition.projectName} - ${condition.permitName}`}</Underlined>
                  </Left>
                </Cell>
                <Cell>
                  <Left>{condition.activityTitleName}</Left>
                </Cell>
                <Cell>
                  <Left>{condition.conditionName}</Left>
                </Cell>
                <Cell>
                  <Left>{condition.statusName}</Left>
                </Cell>
                <Cell>
                  <Left>{condition.followUp}</Left>
                </Cell>
                <Cell>
                  <Left />
                </Cell>
              </Row>
            );
          })}
      </RowsWrapper>
    </Wrapper>
  );
};

export default ConditionsTable;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 200px repeat(5, 1fr);
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  border-left: 1px solid var(--border);
  border-radius: 6px;
`;
